/* Production-ready gallery display improvements. Original form, API and purchase controllers remain intact. */
(() => {
  'use strict';
  const runtime = window.CovermaticRuntime;
  if (!runtime || runtime.__displayOptimized) return;
  runtime.__displayOptimized = true;
  const map = window.CovermaticThumbnails || {};
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const fullURL = value => new URL(value, location.href).href;
  function revealImages(root = document) {
    root.querySelectorAll('img[data-cm-src]').forEach(img => {
      if (!img.getClientRects().length || img.closest('.hidden')) return;
      // Hidden slideshow slides are hydrated only as they become active.
      const slide = img.closest('[data-signature-slide]');
      if (slide && !slide.classList.contains('is-active')) return;
      if (img.dataset.cmSrcset) img.srcset = img.dataset.cmSrcset;
      img.src = img.dataset.cmSrc;
      delete img.dataset.cmSrc; delete img.dataset.cmSrcset;
    });
  }
  const descriptions = [
    'Run It Up: illustrated rapper holding cash', 'WOAH!: singer performing under stage lights',
    'Flawless Victory: illustrated champion with a gold belt', 'Electric Midnight: leopard surrounded by blue lightning',
    'Night Shift Grind: silhouette against a purple city skyline', 'Diamond Dreams: dark luxury car and jewelry',
    'Shatterproof: glowing guitar above a blue city'
  ];
  runtime.GalleryController.prototype.renderGuestGallery = function () {
    const container = document.getElementById('guest-examples-container');
    if (container && !container.dataset.cmRendered) {
      container.dataset.cmRendered = 'true';
      runtime.Config.guestImages.forEach((item, index) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'covermatic-gallery-card covermatic-gallery-card--guest group relative flex-none w-40 md:w-60 snap-center text-left';
        btn.dataset.url = item.URL; // Full-resolution viewer target remains unchanged.
        const alt = descriptions[index] || `${item['Song/Album Name'] || 'Covermatic'} cover example`;
        btn.setAttribute('aria-label', `View ${alt}`);
        const frame = document.createElement('div'); frame.className = 'covermatic-gallery-card__frame';
        const media = document.createElement('div'); media.className = 'covermatic-gallery-card__media';
        const img = document.createElement('img');img.className = 'covermatic-gallery-card__image';
        const thumb = map[fullURL(item.URL)];
        img.alt = alt; img.loading = 'lazy'; img.decoding = 'async';
        img.width = thumb?.width || 1; img.height = thumb?.height || 1;
        if (thumb) { img.srcset = `${thumb.small} 240w, ${thumb.large} 480w`; img.sizes = '(max-width: 767px) 136px, 216px'; }
        img.src = thumb?.large || item.URL;
        media.append(img);frame.append(media);btn.append(frame);container.append(btn);
      });
    }
    ['guest-examples-container','guest-premade-container','guest-promo-container'].forEach(id => this.initMarquee(id));
  };
  runtime.GalleryController.prototype.initMarquee = function (id) {
    const el = document.getElementById(id);
    if (!el || el.dataset.cmScrollReady) return;
    el.dataset.cmScrollReady = 'true'; el.classList.add('cm-gallery-scroll');
    el.setAttribute('role', 'region'); el.setAttribute('aria-label', id.includes('premade') ? 'Premade cover examples' : id.includes('promo') ? 'Promo graphic examples' : 'Generated cover examples');
    const controls = document.createElement('div');controls.className = 'cm-gallery-controls';
    [-1, 1].forEach(direction => {
      const btn = document.createElement('button');btn.type = 'button';btn.textContent = direction < 0 ? 'Previous' : 'Next';
      btn.setAttribute('aria-controls', id);btn.setAttribute('aria-label', `${btn.textContent} ${el.getAttribute('aria-label').toLowerCase()}`);
      btn.addEventListener('click', () => {
        const end = el.scrollWidth - el.clientWidth;
        const left = direction > 0 && el.scrollLeft >= end - 4 ? 0 : direction < 0 && el.scrollLeft <= 4 ? end : el.scrollLeft + direction * el.clientWidth * .8;
        el.scrollTo({left, behavior: reduced.matches ? 'auto' : 'smooth'});
      });controls.append(btn);
    });el.after(controls);
  };
  // Original slideshow selection is retained; hidden slides no longer download or run timers.
  runtime.Utils.initSignatureSlideshows = (root = document) => {
    root.querySelectorAll('[data-signature-slideshow]').forEach(el => {
      if (el.dataset.slideshowInitialized) return;
      el.dataset.slideshowInitialized = 'true';
      const slides = [...el.querySelectorAll('[data-signature-slide]')];let index = 0, timer;
      const show = () => { slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));revealImages(el); };
      show();
      const observer = new IntersectionObserver(entries => {
        clearInterval(timer);
        if (entries[0].isIntersecting && !reduced.matches && slides.length > 1) timer = setInterval(() => {index = (index + 1) % slides.length;show();}, 3200);
      });observer.observe(el);
      reduced.addEventListener('change', () => {if (reduced.matches) clearInterval(timer);});
    });
  };
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;scheduled = true;
    requestAnimationFrame(() => {scheduled = false;revealImages();});
  }).observe(document.getElementById('covermatic-app'), {subtree:true, attributes:true, attributeFilter:['class']});
  document.addEventListener('DOMContentLoaded', () => revealImages());
})();
/* Focus support delegates close/selection to the original modal controllers. */
(() => {
  const dialogs = [...document.querySelectorAll('#covermatic-app [role="dialog"]')];
  const stack = [], openers = new WeakMap();
  const visible = el => !el.classList.contains('hidden') && el.getClientRects().length > 0;
  const focusable = dialog => [...dialog.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter(el => el.getClientRects().length && !el.closest('.hidden'));
  dialogs.forEach(dialog => {
    if (!dialog.hasAttribute('aria-label') && !dialog.hasAttribute('aria-labelledby')) {
      const heading = dialog.querySelector('h2,h3');
      if (heading) { heading.id ||= `${dialog.id}-heading`; dialog.setAttribute('aria-labelledby', heading.id); }
      else dialog.setAttribute('aria-label', 'Artwork preview');
    }
    dialog.querySelectorAll('[data-close="x"]').forEach(button => button.setAttribute('aria-label', 'Close dialog'));
    let wasOpen = visible(dialog);
    new MutationObserver(() => {
      const isOpen = visible(dialog);if (wasOpen === isOpen) return;wasOpen = isOpen;
      if (isOpen) {
        openers.set(dialog, document.activeElement);stack.push(dialog);
        queueMicrotask(() => {if (visible(dialog)) (focusable(dialog)[0] || dialog).focus({preventScroll:true});});
      } else {
        const at = stack.indexOf(dialog);if (at >= 0) stack.splice(at, 1);
        const opener = openers.get(dialog);
        queueMicrotask(() => {if (stack.length) return; if (opener?.isConnected && opener.getClientRects().length) opener.focus({preventScroll:true});});
      }
    }).observe(dialog, {attributes:true,attributeFilter:['class','style']});
  });
  document.addEventListener('keydown', event => {
    const dialog = [...stack].reverse().find(visible);if (!dialog) return;
    if (event.key === 'Escape') {
      const close = dialog.querySelector('[data-close="x"], [aria-label^="Close"]');
      if (close) {event.preventDefault();event.stopImmediatePropagation();close.click();}
    } else if (event.key === 'Tab') {
      const items = focusable(dialog), first = items[0], last = items.at(-1);
      if (!first) {event.preventDefault();return;}
      if (!dialog.contains(document.activeElement) || (event.shiftKey && document.activeElement === first)) {event.preventDefault();(event.shiftKey ? last : first).focus();}
      else if (!event.shiftKey && document.activeElement === last) {event.preventDefault();first.focus();}
    }
  }, true);
})();
